var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkLiftLgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13645 1.31823V5.58529C1.13645 5.64857 1.11994 5.71076 1.08854 5.7657L0.457091 6.87074C0.425694 6.92568 0.40918 6.98787 0.40918 7.05115V11.3182C0.40918 11.519 0.571985 11.6819 0.772816 11.6819H8.22735C8.42819 11.6819 8.59099 11.519 8.59099 11.3182V7.96578C8.59099 7.79891 8.47743 7.65347 8.31555 7.613L8.04093 7.54434C7.92943 7.51647 7.83767 7.43752 7.79346 7.33142L5.22969 1.17837C5.17323 1.04286 5.04082 0.95459 4.89402 0.95459H1.50009C1.29926 0.95459 1.13645 1.1174 1.13645 1.31823Z",
    stroke: "white",
    strokeWidth: 0.363636
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50013 1.68201H2.22741C2.02658 1.68201 1.86377 1.84481 1.86377 2.04564V5.682C1.86377 5.88283 2.02657 6.04564 2.22741 6.04564H3.50013C3.61459 6.04564 3.72237 6.09953 3.79104 6.19109L4.66377 7.35473C4.73244 7.44629 4.84022 7.50018 4.95468 7.50018H7.86376",
    stroke: "white",
    strokeWidth: 0.363636
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68176 0.590942L10.8751 10.8805C10.9223 11.0327 11.0631 11.1364 11.2224 11.1364H13.8636",
    stroke: "white",
    strokeWidth: 0.363636,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.86372,
    cy: 10.9545,
    r: 1.27273,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.363636
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.68184,
    cy: 11.3183,
    r: 1.27273,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.363636
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkLiftLgt);
export default __webpack_public_path__ + "static/media/Fork Lift-lgt.9f7ac2883d5b165e0d22ea26b7a21a76.svg";
export { ForwardRef as ReactComponent };